
import React from "react";
import { useLocation, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sun } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  React.useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-warm-cream p-4">
      <div className="text-center max-w-md">
        <Sun className="h-16 w-16 text-yellow-500 mx-auto mb-4 animate-sunshine" />
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-6">
          Oops! We couldn't find that page. The sun must be shining somewhere else.
        </p>
        <Button asChild>
          <Link to="/">Return to Sunny Terraces</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
